module.exports = __webpack_public_path__ + "img/050501_de beukelaer-groß.675f1f6e.jpg";